import { ol_Coordinate, ol_Feature, ol_geom } from "@omnia/exports/openlayers";
import { GcpPoint } from "./gcp-point";
import { IGcpMap, IGeorefReprojectedImage, IGeorefSourceImage } from "./types";

/// <reference path="gcp-point.ts" />

export class GcpContext {

    private _points: GcpPoint[];
    private _currentPoint: GcpPoint;

    private _maps: IGcpMap[];

    private _sourceRasterDoc: IGeorefSourceImage;

    public targetBoundary: ol_geom.Geometry;
    public reprojectedImage: IGeorefReprojectedImage;


    private _editMode: boolean = true;
    private _addPointMode: boolean;


    constructor(private watcher: () => void) {
        this._points = [];
        this._maps = [];
        this.watcher = this.watcher || (() => { });
    }

    get editMode(): boolean {
        return this._editMode;
    }

    set editMode(value: boolean) {
        this._editMode = value;
        if (!value) this._addPointMode = false;
        this._maps.forEach(m => m.editMode = value);
    }

    get addPointMode(): boolean {
        return this._addPointMode;
    }

    set addPointMode(value: boolean) {
        this._addPointMode = this._editMode && value;
    }

    get sourceRasterDoc(): IGeorefSourceImage {
        return this._sourceRasterDoc;
    }

    get sourceRasterSize(): number[] {

        if (this._sourceRasterDoc) {
            return [this._sourceRasterDoc.Width, this._sourceRasterDoc.Height];
        }

    }

    setSourceRasterDoc(doc: IGeorefSourceImage) {
        this._sourceRasterDoc = doc;
    }

    public registerMap(map: IGcpMap) {
        if (this._maps.indexOf(map) <= 0) {
            this._maps.push(map);
        }
    }

    public canAddNewPoints(): boolean {
        return !!this.sourceRasterDoc;
    }

    get points(): GcpPoint[] {
        return this._points;
    }

    getPoints(complete: boolean = true): GcpPoint[] {
        return this._points.filter(p => (!complete) || p.isComplete());
    }

    get currentPoint(): GcpPoint {
        return this._currentPoint;
    }

    public addPoint(coord: ol_Coordinate, raster: boolean): GcpPoint {

        let point = new GcpPoint();
        point.number = !this._points.length ? 1 : this._points.map(p => p.number).sort((n1, n2) => n2 - n1)[0] + 1

        let feature = this.createFeature(point, coord);

        point.map = raster ? null : feature;
        point.raster = raster ? feature : null

        this._points.push(point);

        this.addPointMode = false;

        this.watcher();

        return point;

    }

    public setCurrentPoint(point: GcpPoint) {
        this._currentPoint = point;
        this._maps.forEach(m => m.refresh());
    }

    public completePoint(point: GcpPoint, coord: ol_Coordinate): ol_Feature {

        if (point.map && point.raster) {
            throw new Error();
        }

        let feature = this.createFeature(point, coord);

        if (!point.map) {
            point.map = feature;
        }
        else {
            point.raster = feature;
        }

        this.watcher();

        return feature;

    }

    private createFeature(point: GcpPoint, coord: ol_Coordinate): ol_Feature {
        let geom = new ol_geom.Point(coord);
        let feature = new ol_Feature(geom);
        feature.set("data", point);
        return feature;
    }

    public refreshLayers() {
        this._maps.forEach(m => m.refresh());
    }

    public reset() {
        this._currentPoint = null;
        this._points = [];
        this.refreshLayers();
    }

    public deletePoint(del: GcpPoint) {

        this._points = this._points.filter(p => p != del);
        this._points.forEach((p, index) => p.number = (index + 1));
        this._currentPoint = (this._currentPoint == del ? null : this._currentPoint);

    }

}
